import { ref } from 'vue';

// Global loading state
const isLoading = ref(false);
const loadingMessage = ref('');

export function useLoading() {
    const showLoading = (message = '') => {
        isLoading.value = true;
        loadingMessage.value = message;
    };

    const hideLoading = () => {
        isLoading.value = false;
        loadingMessage.value = '';
    };

    const withLoading = async (asyncFn, message = '') => {
        try {
            showLoading(message);
            const result = await asyncFn();
            return result;
        } finally {
            hideLoading();
        }
    };

    return {
        isLoading,
        loadingMessage,
        showLoading,
        hideLoading,
        withLoading
    };
}